import { ButtonAppearance as FluentButtonAppearance, ButtonShape as FluentButtonShape, ButtonSize as FluentButtonSize, ButtonFormTarget as FluentButtonFormTarget, ButtonType as FluentButtonType } from "@fluentui/web-components";
/** Appearance values for {@link Button}. */
export const ButtonAppearances = {
    ...FluentButtonAppearance,
    primaryOnBrand: "primary-on-brand"
};
/** Shape values for {@link Button}. */
export const ButtonShapes = { ...FluentButtonShape };
/** Size values for {@link Button}. */
export const ButtonSizes = { ...FluentButtonSize };
/** Form target values for {@link Button}. */
export const ButtonFormTargets = { ...FluentButtonFormTarget };
4;
/** Button type values for {@link Button}. */
export const ButtonTypes = { ...FluentButtonType };
//# sourceMappingURL=button.options.js.map